import { IEventData } from 'meta/pages/v4/event'
import { ILocationData } from 'meta/pages/v4/location'
import { IWalletEvent } from 'meta/pages/v4/wallet'

import { useEventData } from 'hooks/useEvent'
import { useLocationData } from 'hooks/useLocation'

import WalletTicketDesktop from './WalletTicketDesktop'
import { WalletTicketDesktopSkeleton } from './WalletTicketDesktopSkeleton'

type EventProps = {
  isPastEvent?: boolean
  walletEventData: IWalletEvent
}

type LocationProps = {
  baseProps: EventProps
  eventData: IEventData
}

export type WalletTicketDesktopProps = {
  baseProps: EventProps
  eventData: IEventData
  locationData: ILocationData
}

const EventContainer: React.FC<EventProps> = (props) => {
  const { walletEventData } = props

  const eventData = useEventData({ idOrCodeUrl: String(walletEventData.id) })

  if (!eventData) {
    return <WalletTicketDesktopSkeleton />
  }

  return <LocationContainer eventData={eventData} baseProps={props} />
}

const LocationContainer: React.FC<LocationProps> = (props) => {
  const { baseProps, eventData } = props

  const locationData = useLocationData({ idOrCodeUrl: String(eventData.locationId) })

  if (!locationData) {
    return <WalletTicketDesktopSkeleton />
  }

  return <WalletTicketDesktop locationData={locationData} eventData={eventData} baseProps={baseProps} />
}

export default EventContainer
